// extracted by mini-css-extract-plugin
export default {"border":"Table_border__18UI6","table":"Table_table__woH5r","link":"Table_link__P96Uk"};